"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SocialLink = _interopRequireDefault(require("../SocialLink"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Dependencies

// Main class export
class Social extends _react.default.Component {
  renderLinks() {
    if (this.props.list.length <= 0) {
      return false;
    }
    return this.props.list.map(function (link, i) {
      return /*#__PURE__*/_react.default.createElement(_SocialLink.default, {
        key: i,
        network: link.text,
        href: link.href
      });
    }.bind(this));
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        padding: '24px 0 14px 0'
      }
    }, this.renderLinks());
  }
}
exports.default = Social;
;
Social.propTypes = {
  list: _propTypes.default.array
};
Social.defaultProps = {
  list: []
};